import {
	CLEAR_RULES,
	GET_RULES,
	GET_ROLES,
	ADD_RULE,
	DROP_RULE,
	RULE_ERROR,
} from '../mutations.js'


const state = {
	rules: [],
	roles: [],
	message: '',
}

const mutations = {
	[CLEAR_RULES](state, value) {
		state.rules = []
		state.message = ''
	},
	[GET_RULES](state, value) {
		state.rules = value
		state.message = ''
	},
	[GET_ROLES](state, value) {
		state.roles = value
		state.message = ''
	},
	[ADD_RULE](state, value) {
		state.rules.push(value)
		state.message = ''
	},
	[DROP_RULE](state, value) {
		state.rules = _.reject(state.rules, value)
		state.message = ''
	},
	[RULE_ERROR](state, value) {
		state.message = value
	},
}

const actions = {
	fetchRules({
		commit
	}) {
		this.$http.get('rules').then(
			(response) => {
				commit(GET_RULES, response.data)
			}
		)
		this.$http.get('roles').then(
			(response) => {
				commit(GET_ROLES, response.data)
			}
		)
	},
	dropRule({
		commit
	}, rule) {
		this.$http.delete(`rules/${rule.id}`).then(
			(response) => {
				if (response.status != 204) {
					commit(RULE_ERROR, response.data.message)
				} else {
					commit(DROP_RULE, rule)
				}
			}
		)
	},
	addRule({
		commit
	}, rule) {
		this.$http.post('rules', rule).then(
			(response) => {
				if (response.status != 200) {
					commit(RULE_ERROR, response.data.message)
				} else {
					rule.id = response.data.id
					commit(ADD_RULE, rule)
				}
			}
		)
	},
}

export default {
	actions,
	state,
	mutations
}
